import React from "react";
import ReactDOM from "react-dom/client"; // Assurez-vous que 'react-dom/client' est importé
import App from "./App";

// Récupère l'élément root
const rootElement = document.getElementById("root");

// Crée un root et rend l'application
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
